
  import { defineComponent } from "vue";

  import { get, has, isEmpty, without } from "lodash";

  import { applicationViewModes } from "@/helpers/utils";
  import DmClientProductDocumentsV2 from "@/components/processComponents/v2/DmClientProductDocumentsV2.vue";
  import FileUploadV2 from "@/components/processComponents/v2/FileUploadV2.vue";
  import FileUploadFormV2 from "@/components/processComponents/v2/FileUploadFormV2.vue";
  import FormGroupV2 from "@/components/processComponents/v2/FormGroupV2.vue";
  import HiddenFieldV2 from "@/components/processComponents/v2/HiddenFieldV2.vue";
  import NumericInput from "@/components/processComponents/v2/NumericInput.vue";
  import NumericInputV2 from "@/components/processComponents/v2/NumericInputV2.vue";
  import SimpleContainer from "@/components/processComponents/v2/SimpleContainer.vue";
  import SimpleContainerV2 from "@/components/processComponents/v2/SimpleContainerV2.vue";
  import SimpleInputV2 from "@/components/processComponents/v2/SimpleInputV2.vue";
  import SimpleLabel from "@/components/processComponents/SimpleLabel.vue";
  import SimpleSelectV2 from "@/components/processComponents/v2/SimpleSelectV2.vue";
  import FormTitle from "@/components/processComponents/FormTitle.vue";
  import SimpleDateV2 from "@/components/processComponents/v2/SimpleDateV2.vue";
  import SimpleSwitchV2 from "@/components/processComponents/v2/SimpleSwitchV2.vue";
  import HeadingV2 from "@/components/processComponents/v2/HeadingV2.vue";
  import FormRepeaterV2 from "@/components/processComponents/v2/FormRepeaterV2.vue";
  import FormContainerV2 from "@/components/processComponents/v2/FormContainerV2.vue";
  import QuoteResultsRender from "@/components/processComponents/QuoteResultsRender.vue";
  import MapV2 from "@/components/processComponents/v2/MapV2.vue";
  import QuoteResultsRendererV2 from "@/components/processComponents/v2/QuoteResultsRendererV2.vue";
  import MessageBox from "@/components/processComponents/MessageBox.vue";

  export default defineComponent({
    name: "ProcessComponentsIteratorV2",

    components: {
      DmClientProductDocumentsV2,
      FileUploadV2,
      FileUploadFormV2,
      FormContainerV2,
      FormGroupV2,
      FormRepeaterV2,
      MapV2,
      FormTitle,
      HiddenFieldV2,
      MessageBox,
      NumericInput,
      NumericInputV2,
      QuoteResultsRender,
      QuoteResultsRendererV2,
      SimpleContainer,
      SimpleContainerV2,
      SimpleDateV2,
      SimpleLabel,
      SimpleInputV2,
      SimpleSelectV2,
      SimpleSwitchV2,
      HeadingV2,
    },

    props: {
      components: {
        type: Array,
        required: true,
      },

      layout: {
        type: String,
        required: false,
        default: "horizontal",
      },

      path: {
        type: String,
        required: false,
        default: "form.data",
      },

      contextPath: {
        type: String,
        required: false,
        default: "",
      },

      viewMode: {
        type: String,
        required: false,
        default: () => applicationViewModes.visualization,
      },
    },

    methods: {
      buildPath(component: any): any {
        let path = [this.path];

        const attributes = this.getAttributes(component);

        if (has(attributes, "name") && !isEmpty(attributes.name)) {
          path.push(attributes.name);
        }

        if (has(attributes, "cname")) {
          path.push(attributes.cname);
        }

        return without(path, "").join(".");
      },

      getAttributes(component: any): any {
        return get(component, "settings.attributes", get(component, "attributes", {}));
      },

      getKey(component: any, index: number): string {
        const attributes = this.getAttributes(component);

        if (has(attributes, "name")) {
          return `${component.id}-${attributes.name}-${index}`;
        }

        return `${component.id}-${index}`;
      },
    },
  });
